module.exports = __webpack_public_path__ + "static/media/03-2.d2d391d1.webp";